import Head from 'expo-router/head';

import { Receipt } from '@fhs-legacy/frontend/src/pages/receipt';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function ReceiptPage() {
  return (
    <>
      <Head>
        <title>Receipt - Firehouse Subs</title>
      </Head>
      <Receipt />
    </>
  );
}
